<template>
    <div id="app">
        <div class="container">
            <header>
                <h1> <el-icon>
                        <EditPen />
                    </el-icon>题目录入系统</h1>
                <p class="subtitle">支持单题录入和整卷录入两种模式，满足不同场景下的题目管理需求</p>
            </header>

            <div class="card">
                <div class="mode-selector">
                    <div class="mode-btn" :class="{ active: mode === 'single' }" @click="mode = 'single'">
                        <!-- <i class="fas fa-file-alt mode-icon"></i> -->
                        <el-icon class="mode-icon">
                            <Document />
                        </el-icon>
                        <div class="mode-title">单题录入模式</div>
                        <div class="mode-desc">一次录入一道题目，适合日常积累</div>
                    </div>

                    <div class="mode-btn" :class="{ active: mode === 'paper' }" @click="mode = 'paper'">
                        <!-- <i class="fas fa-book mode-icon"></i> -->
                        <el-icon class="mode-icon">
                            <Notebook />
                        </el-icon>
                        <div class="mode-title">整卷录入模式</div>
                        <div class="mode-desc">录入整张试卷，包含多道题目</div>
                    </div>
                </div>

                <div v-if="mode === 'paper'" class="form-group">
                    <label><i class="fas fa-bookmark"></i> 试卷名称</label>
                    <input type="text" v-model="paperTitle" placeholder="请输入试卷名称">
                </div>

                <div class="form-group">
                    <label><i class="fas fa-question-circle"></i> 题干</label>
                    <!-- <textarea v-model="currentQuestion.content" placeholder="请输入题目内容..."></textarea> -->
                    <md-editor preview-theme="cyanosis" :editorId="input_content" v-model="currentQuestion.content"
                        style="text-align: left; max-height: 200px;" @on-upload-img="onUploadImg" />
                </div>

                <div class="input-row">
                    <div class="form-group">
                        <label><i class="fas fa-tag"></i> 题型</label>
                        <select v-model="currentQuestion.type">
                            <option value="single_choice">单选题</option>
                            <option value="multiple_choice">多选题</option>
                            <option value="fill_in">填空题</option>
                            <option value="essay">解答题</option>
                            <option value="proof">证明题</option>
                            <option value="application">应用题</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label><i class="fas fa-brain"></i> 难度</label>
                        <select v-model="currentQuestion.difficult">
                            <option value="容易">容易</option>
                            <option value="较易">较易</option>
                            <option value="适中">适中</option>
                            <option value="较难">较难</option>
                            <option value="困难">困难</option>
                        </select>
                    </div>
                </div>

                <div class="input-row">
                    <div class="form-group">
                        <label><i class="fas fa-calendar"></i> 年份</label>
                        <input type="text" v-model="currentQuestion.year" placeholder="例如：2023">
                    </div>

                    <div class="form-group">
                        <label><i class="fas fa-map-marker-alt"></i> 地区</label>
                        <!-- <input type="text" v-model="currentQuestion.area" placeholder="例如：北京市"> -->
                        <el-cascader size="large" :options="pcTextArr" v-model="currentQuestion.area"></el-cascader>
                    </div>

                    <div class="form-group">
                        <label><i class="fas fa-graduation-cap"></i> 年级</label>
                        <select v-model="currentQuestion.grade">
                            <option value="高一">高一</option>
                            <option value="高二">高二</option>
                            <option value="高三">高三</option>
                        </select>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <label><i class="fas fa-tags"></i> 知识点</label>
                    <input type="text" v-model="currentQuestion.knowledgePoint" placeholder="例如：三角函数、集合">
                </div> -->
                <div class="form-group">
                    <label><i class="fas fa-tags"></i> 来源</label>
                    <input type="text" v-model="currentQuestion.source" placeholder="例如：2024年上海高考数学秋考">
                </div>

                <!-- 知识点输入 -->
                <div class="form-group">
                    <label><i class="fas fa-tags"></i> 知识点</label>

                    <div class="tag-container">
                        <span class="tag" v-for="(knowledgePoint, index) in currentQuestion.knowledgePoints"
                            :key="index">
                            <el-icon>
                                <CollectionTag />
                            </el-icon>
                            {{ knowledgePoint }}
                        </span>
                    </div>

                    <div class="tag-input">
                        <input type="text" v-model="newknowledgePoint" placeholder="输入标签后按回车添加"
                            @input="filterknowledgePointSuggestions" @keydown.enter.prevent="addknowledgePoint"
                            list="knowledgePoint-suggestions" />
                        <datalist id="knowledgePoint-suggestions">
                            <option v-for="knowledgePoint in filteredknowledgePoints" :key="knowledgePoint.id"
                                :value="knowledgePoint.name" />
                        </datalist>

                        <button class="add-tag-btn" @click="addknowledgePoint">添加</button>
                    </div>
                </div>

                <!-- 标签输入2 -->

                <div class="form-group">
                    <label><i class="fas fa-tags"></i> 标签</label>

                    <div class="tag-container">
                        <span class="tag" v-for="(tag, index) in currentQuestion.tags" :key="index">
                            <el-icon>
                                <CollectionTag />
                            </el-icon>
                            {{ tag }}
                        </span>
                    </div>

                    <div class="tag-input">
                        <input type="text" v-model="newTag" placeholder="输入标签后按回车添加，例如典型题、压轴题、同步题、新文化题、课本原题"
                            @input="filterTagSuggestions" @keydown.enter.prevent="addTag" list="tag-suggestions" />
                        <datalist id="tag-suggestions">
                            <option v-for="tag in filteredTags" :key="tag.id" :value="tag.name" />
                        </datalist>

                        <button class="add-tag-btn" @click="addTag">添加</button>
                    </div>
                </div>

                <!-- 单选题选项 -->
                <div v-if="currentQuestion.type === 'single_choice' || currentQuestion.type === 'multiple_choice'"
                    class="form-group">
                    <label><i class="fas fa-list-ol"></i> 题目选项</label>
                    <div class="options-container">
                        <div class="option-item" v-for="(option, index) in currentQuestion.options" :key="index">
                            <div class="option-label">{{ String.fromCharCode(65 + index) }}</div>
                            <input type="text" v-model="currentQuestion.options[index]"
                                :placeholder="'选项 ' + String.fromCharCode(65 + index)">
                            <md-editor preview-only="" preview-theme="cyanosis" v-model="currentQuestion.options[index]"
                                style="text-align: left; max-height: 200px;" />
                        </div>
                        <el-form-item label="答案">
                            <el-radio-group v-model="currentQuestion.singleAnswer">
                                <el-radio value="A">A</el-radio>
                                <el-radio value="B">B</el-radio>
                                <el-radio value="C">C</el-radio>
                                <el-radio value="D">D</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group">
                    <label><i class="fas fa-check-circle"></i> 答案</label>
                    <!-- <textarea v-model="currentQuestion.answer" placeholder="请输入题目答案..."></textarea> -->
                    <md-editor preview-theme="cyanosis" v-model="currentQuestion.answer"
                        style="text-align: left;max-height: 200px;" />
                </div>

                <div class="form-group">
                    <label><i class="fas fa-lightbulb"></i> 解析</label>
                    <!-- <textarea v-model="currentQuestion.explanation" placeholder="请输入题目解析..."></textarea> -->
                    <md-editor id="explanation" preview-theme="cyanosis" v-model="currentQuestion.explanation"
                        style="text-align: left;max-height: 200px;" />
                </div>

                <div class="btn-group">
                    <button class="btn btn-secondary" @click="resetForm">
                        <i class="fas fa-redo"></i> 重置表单
                    </button>

                    <template v-if="mode === 'single'">
                        <button class="btn btn-primary" @click="submitSingleQuestion">
                            <i class="fas fa-paper-plane"></i> 提交题目
                        </button>
                    </template>

                    <template v-else>
                        <button class="btn btn-primary" @click="addToPaper">
                            <i class="fas fa-plus-circle"></i> 添加到试卷
                        </button>
                    </template>
                </div>

                <!-- 整卷模式下的题目列表 -->
                <div v-if="mode === 'paper' && paperQuestions.length > 0" class="question-list">
                    <h2><i class="fas fa-list"></i> 试卷题目列表 ({{ paperQuestions.length }}题)</h2>

                    <div class="question-item" v-for="(q, index) in paperQuestions" :key="index">
                        <div class="question-header">
                            <div class="question-title">题目 #{{ index + 1 }}</div>
                            <div class="question-meta">
                                <span class="meta-item">
                                    <i class="fas fa-tag"></i> {{ getQuestionTypeText(q.type) }}
                                </span>
                                <span class="meta-item">
                                    <i class="fas fa-brain"></i> {{ q.difficult }}
                                </span>
                            </div>
                        </div>

                        <div class="question-content">{{ q.content }}</div>

                        <div v-if="q.options && q.options.length > 0">
                            <strong>选项：</strong>
                            <ol class="option-list">
                                <li v-for="(option, idx) in q.options" :key="idx">
                                    {{ String.fromCharCode(65 + idx) }}. {{ option }}
                                </li>
                            </ol>
                        </div>

                        <div class="answer-section">
                            <div class="answer-title">
                                <i class="fas fa-check-circle"></i> 答案与解析
                            </div>
                            <div class="answer-content">
                                <div><strong>答案：</strong> {{ q.answer }}</div>
                                <div v-if="q.explanation" style="margin-top: 15px;">
                                    <strong>解析：</strong> {{ q.explanation }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn-group">
                        <button class="btn btn-secondary" @click="resetPaper">
                            <i class="fas fa-trash-alt"></i> 清空试卷
                        </button>
                        <button class="btn btn-primary" @click="submitPaper">
                            <i class="fas fa-paper-plane"></i> 提交整卷
                        </button>
                    </div>
                </div>
            </div>

            <!-- 预览区域 -->
            <div class="card preview-area">
                <h2 class="preview-title"><i class="fas fa-eye"></i> 题目预览</h2>

                <div v-if="!currentQuestion.content" class="empty-state">
                    <i class="fas fa-file-alt"></i>
                    <h3>暂无题目内容</h3>
                    <p>请在左侧表单中输入题目内容，预览将在此处显示</p>
                </div>

                <div v-else class="question-item">
                    <div class="question-header">
                        <div class="question-title">题目预览</div>
                        <div class="question-meta">
                            <span class="meta-item">
                                <i class="fas fa-tag"></i> {{ getQuestionTypeText(currentQuestion.type) }}
                            </span>
                            <span class="meta-item">
                                <i class="fas fa-brain"></i> {{ currentQuestion.difficult || '未设置' }}
                            </span>
                            <span class="meta-item">
                                <i class="fas fa-graduation-cap"></i> {{ currentQuestion.grade || '未设置' }}
                            </span>
                        </div>
                    </div>

                    <!-- <div class="question-content">{{ currentQuestion.content }}</div> -->
                    <md-editor preview-only preview-theme="cyanosis" v-model="currentQuestion.content"
                        style="text-align: left;" />

                    <div v-if="currentQuestion.options && currentQuestion.options.length > 0">
                        <strong>选项：</strong>
                        <ol class="option-list">
                            <li v-for="(option, idx) in currentQuestion.options" :key="idx">
                                {{ String.fromCharCode(65 + idx) }}. {{ option }}
                            </li>
                        </ol>
                    </div>

                    <div class="answer-section">
                        <div class="answer-title">
                            <i class="fas fa-check-circle"></i> 答案与解析
                        </div>
                        <div class="answer-content">
                            <div><strong>答案：</strong> {{ currentQuestion.answer || '未填写' }}</div>
                            <div v-if="currentQuestion.explanation" style="margin-top: 15px;">
                                <strong>解析：</strong> {{ currentQuestion.explanation }}
                            </div>
                        </div>
                    </div>

                    <div class="question-meta" style="margin-top: 20px;">
                        <span class="meta-item" v-if="currentQuestion.year">
                            <i class="fas fa-calendar"></i> {{ currentQuestion.year }}年
                        </span>
                        <span class="meta-item" v-if="currentQuestion.area">
                            <i class="fas fa-map-marker-alt"></i> {{ currentQuestion.area }}
                        </span>
                        <span class="meta-item" v-if="currentQuestion.knowledgePoints.length > 0">
                            <span class="tag" v-for="knowledgePoint in currentQuestion.knowledgePoints">
                                <i class="fas fa-tag"></i> {{ knowledgePoint }}
                            </span>
                        </span>
                        <span class="meta-item" v-if="currentQuestion.source">
                            <i class="fas fa-lightbulb"></i> {{ currentQuestion.source }}
                        </span>
                    </div>

                    <div class="tag-container" v-if="currentQuestion.tags.length > 0" style="margin-top: 15px;">
                        <span class="tag" v-for="tag in currentQuestion.tags">
                            <i class="fas fa-tag"></i> {{ tag }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, reactive, computed, watch } from 'vue'
import {
    provinceAndCityData,
    pcTextArr,
    regionData,
    pcaTextArr,
    codeToText,
} from "element-china-area-data";
import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';

// 录入模式：single(单题) 或 paper(整卷)
const mode = ref('single');

// 试卷标题（整卷模式使用）
const paperTitle = ref('');

// 当前正在编辑的题目
const currentQuestion = reactive({
    content: '数列$\\left\\{ a_{n} \\right\\}$中，$a_{1} = 1,a_{n + 1} = a_{n} + 2^{n}$，则$a_{4} =\\_\\_\\_\\_$.',
    type: 'fill_in',
    difficult: '适中',
    year: '2025',
    area: '',
    grade: '高一',
    knowledgePoints: [],
    knowledgePointIds: [],
    tags: [],
    options: ['', '', '', ''],
    answer: '$- \\frac{1}{4}/-0.25$',
    explanation: '',
    source: '上海市川沙中学2024-2025学年高二上学期10月月考数学试卷',
    tagIds: [],           // 标签ID列表
    singleAnswer: '',
});

// 新标签输入
const newTag = ref('');

// 整卷模式下的题目列表
const paperQuestions = ref([]);

// const newTag = ref('')
const allTags = ref([])         // 所有标签（id + name）
const filteredTags = ref([])    // 输入时过滤结果
// 获取所有标签
const fetchAllTags = async () => {
    try {
        const res = await axios.get('/api/tags')
        allTags.value = res.data
    } catch (err) {
        console.error('标签加载失败', err)
    }
}

// 输入时过滤已有标签
const filterTagSuggestions = () => {
    const keyword = newTag.value.trim().toLowerCase()
    filteredTags.value = allTags.value.filter(tag =>
        tag.name.toLowerCase().includes(keyword)
    )
}

const onUploadImg = async (files, callback) => {
    const res = await Promise.all(
        files.map((file) => {
            return new Promise((rev, rej) => {
                const form = new FormData();
                form.append('file', file);
                form.append('filename', `problem_${uuidv4().substring(0, 8)}`);
                axios.post('/api/upload/image', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }).then(res => {
                    rev(res);
                })
            });
        })
    );
    callback(res.map((item) => item.data.url));
}

// 添加标签逻辑
const addTag = async () => {
    const name = newTag.value.trim()
    if (name === '') return

    // 是否已有
    const existing = allTags.value.find(t => t.name === name)

    if (existing) {
        // 已存在，加入 name 和 id（去重）
        if (!currentQuestion.tags.includes(name)) {
            currentQuestion.tags.push(name)
            currentQuestion.tagIds.push(existing.id)
        }
    } else {
        // 不存在：先请求创建接口
        try {
            const res = await axios.post('/api/tags', { name })
            const newCreated = res.data.tag
            allTags.value.push(newCreated)
            currentQuestion.tags.push(name)
            currentQuestion.tagIds.push(newCreated.id)
        } catch (err) {
            console.error('标签创建失败', err)
        }
    }

    newTag.value = ''
}

// 知识点输入

const newknowledgePoint = ref('');
const allknowledgePoints = ref([])         // 所有标签（id + name）
const filteredknowledgePoints = ref([])    // 输入时过滤结果
// 获取所有标签
const fetchAllknowledgePoints = async () => {
    try {
        const res = await axios.get('/api/knowledgePoints')
        allknowledgePoints.value = res.data
        console.log(allknowledgePoints.value);
    } catch (err) {
        console.error('标签加载失败', err)
    }
}

// 输入时过滤已有标签
const filterknowledgePointSuggestions = () => {
    const keyword = newknowledgePoint.value.trim().toLowerCase()
    filteredknowledgePoints.value = allknowledgePoints.value.filter(knowledgePoint =>
        knowledgePoint.name.toLowerCase().includes(keyword)
    )
    console.log(filteredknowledgePoints)
}

// 添加标签逻辑
const addknowledgePoint = async () => {
    const name = newknowledgePoint.value.trim()
    if (name === '') return

    // 是否已有
    const existing = allknowledgePoints.value.find(t => t.name === name)

    if (existing) {
        // 已存在，加入 name 和 id（去重）
        if (!currentQuestion.knowledgePoints.includes(name)) {
            currentQuestion.knowledgePoints.push(name)
            currentQuestion.knowledgePointIds.push(existing.id)
        }
    } else {
        // 不存在：先请求创建接口
        try {
            const res = await axios.post('/api/knowledgePoints', { name })
            const newCreated = res.data.knowledgePoint
            allknowledgePoints.value.push(newCreated)
            currentQuestion.knowledgePoints.push(name)
            currentQuestion.knowledgePointIds.push(newCreated.id)
        } catch (err) {
            console.error('标签创建失败', err)
        }
    }

    newknowledgePoint.value = ''
}

// 页面加载时获取标签
onMounted(() => {
    fetchAllTags()
    fetchAllknowledgePoints()
})


// 重置表单
const resetForm = () => {
    currentQuestion.content = '';
    currentQuestion.type = 'single_choice';
    currentQuestion.difficult = '适中';
    currentQuestion.year = '';
    currentQuestion.area = '';
    currentQuestion.grade = '高一';
    currentQuestion.knowledgePoint = '';
    currentQuestion.source = '';
    currentQuestion.tags = [];
    currentQuestion.options = ['', '', '', ''];
    currentQuestion.answer = '';
    currentQuestion.explanation = '';
    newTag.value = '';
};

// 获取题型文本
const getQuestionTypeText = (type) => {
    const typeMap = {
        'single_choice': '单选题',
        'multiple_choice': '多选题',
        'fill_in': '填空题',
        'essay': '解答题',
        'proof': '证明题',
        'application': '应用题'
    };
    return typeMap[type] || type;
};

const getQuestionTypeId = (type) => {
    const typeMap = {
        'single_choice': 1,
        'multiple_choice': 6,
        'fill_in': 2,
        'essay': 3,
        'proof': 4,
        'application': 5
    };
    return typeMap[type] || type;
};

const getDifficultId = (type) => {
    const typeMap = {
        '容易': 1,
        '较易': 2,
        '适中': 3,
        '较难': 4,
        '困难': 5,
    };
    return typeMap[type] || type;
};

const getGradeId = (type) => {
    const typeMap = {
        '高一': 10,
        '高二': 11,
        '高三': 12,
    };
    return typeMap[type] || type;
};

// 提交单题
async function submitSingleQuestion() {
    if (!currentQuestion.content) {
        // alert('请填写题干内容');
        return;
    }

    // 这里应该是提交到API的逻辑
    try {
        const data = {
            content: currentQuestion.content,
            answer: currentQuestion.answer,
            explanation: currentQuestion.explanation,
            subjectId: 2,
            type: getQuestionTypeId(currentQuestion.type),
            difficult: getDifficultId(currentQuestion.difficult),
            grade: getGradeId(currentQuestion.grade),
            year: currentQuestion.year,
            source: currentQuestion.source,
            region: currentQuestion.area[0],
            city: currentQuestion.area[1],
            // chapterId: 
            tagIds: currentQuestion.tagIds,
            knowledgePointIds: currentQuestion.knowledgePointIds,
            options: [
                { "label": "A", "content": currentQuestion.options[0], "isCorrect": currentQuestion.singleAnswer === 'A' },
                { "label": "B", "content": currentQuestion.options[1], "isCorrect": currentQuestion.singleAnswer === 'B' },
                { "label": "C", "content": currentQuestion.options[2], "isCorrect": currentQuestion.singleAnswer === 'C' },
                { "label": "D", "content": currentQuestion.options[3], "isCorrect": currentQuestion.singleAnswer === 'D' }
            ]

        }
        const response = await axios.post('/api/questions', data);
        // 处理成功响应
    } catch (error) {
        console.error('请求失败:', error.response?.data || error.message);
        // 处理错误
    }
    console.log('提交单题:', JSON.parse(JSON.stringify(currentQuestion)));
    // alert('题目提交成功！');
    // resetForm();
};

// 添加到试卷（整卷模式）
const addToPaper = () => {
    if (!currentQuestion.content) {
        alert('请填写题干内容');
        return;
    }

    // 添加到试卷题目列表
    paperQuestions.value.push(JSON.parse(JSON.stringify(currentQuestion)));
    alert('题目已添加到试卷！');
    resetForm();
};

// 提交整卷
const submitPaper = () => {
    if (!paperTitle.value) {
        alert('请输入试卷名称');
        return;
    }

    if (paperQuestions.value.length === 0) {
        alert('请至少添加一道题目到试卷');
        return;
    }

    const paper = {
        title: paperTitle.value,
        questions: JSON.parse(JSON.stringify(paperQuestions.value))
    };

    // 这里应该是提交到API的逻辑
    console.log('提交整卷:', paper);
    alert(`试卷 "${paperTitle.value}" 提交成功！包含 ${paperQuestions.value.length} 道题目`);

    // 重置整卷相关数据
    paperTitle.value = '';
    paperQuestions.value = [];
    resetForm();
};

// 重置整卷
const resetPaper = () => {
    if (confirm('确定要清空当前试卷的所有题目吗？')) {
        paperQuestions.value = [];
    }
};
</script>


<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

body {
    background: linear-gradient(135deg, #f8f9fc, #eef2f7);
    color: #333;
    line-height: 1.6;
    padding: 20px;
    min-height: 100vh;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
}

header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #2c3e50, #1a5276);
    color: white;
    border-radius: 15px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

h1 {
    font-size: 2.5rem;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.subtitle {
    font-size: 1.2rem;
    opacity: 0.9;
    max-width: 800px;
    margin: 0 auto;
}

.card {
    background: white;
    border-radius: 15px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    padding: 30px;
    margin-bottom: 30px;
}

.mode-selector {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
}

.mode-btn {
    flex: 1;
    padding: 25px;
    border-radius: 12px;
    background: white;
    border: 3px solid #e0e6ed;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.mode-btn:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.mode-btn.active {
    border-color: #3498db;
    background: #e3f2ff;
}

.mode-icon {
    font-size: 3rem;
    color: #3498db;
}

.mode-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
}

.mode-desc {
    color: #7f8c8d;
    font-size: 1rem;
}

.form-group {
    margin-bottom: 25px;
}

label {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    gap: 8px;
}

input,
select,
textarea {
    width: 100%;
    padding: 14px;
    border: 2px solid #e0e6ed;
    border-radius: 10px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

input:focus,
select:focus,
textarea:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

textarea {
    min-height: 120px;
    resize: vertical;
}

.input-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.input-row .form-group {
    flex: 1;
    margin-bottom: 0;
}

.options-container {
    margin-top: 20px;
    border: 2px dashed #e0e6ed;
    border-radius: 10px;
    padding: 20px;
    background: #f9fbfd;
}

.option-item {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 8px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.option-label {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #3498db;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    flex-shrink: 0;
}

.tag-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.tag {
    background: #e3f2ff;
    color: #2980b9;
    padding: 8px 15px;
    border-radius: 30px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.tag-input {
    display: flex;
    gap: 10px;
}

.tag-input input {
    flex: 1;
}

.add-tag-btn {
    padding: 0 20px;
    background: #3498db;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
}

.btn-group {
    display: flex;
    gap: 20px;
    margin-top: 30px;
}

.btn {
    flex: 1;
    padding: 16px;
    border: none;
    border-radius: 10px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.3s ease;
}

.btn-primary {
    background: linear-gradient(135deg, #3498db, #2980b9);
    color: white;
    box-shadow: 0 4px 15px rgba(52, 152, 219, 0.4);
}

.btn-primary:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(52, 152, 219, 0.6);
}

.btn-secondary {
    background: #f1f4f8;
    color: #2c3e50;
    border: 2px solid #e0e6ed;
}

.btn-secondary:hover {
    background: #e3ecf7;
}

.question-list {
    margin-top: 30px;
    border-top: 2px solid #f0f4f8;
    padding-top: 30px;
}

.question-item {
    background: white;
    border-radius: 12px;
    padding: 25px;
    margin-bottom: 25px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    border-left: 4px solid #3498db;
}

.question-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.question-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #2c3e50;
}

.question-meta {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.meta-item {
    background: #f0f7ff;
    color: #2980b9;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.question-content {
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 1.8;
    color: #34495e;
}

.option-list {
    margin: 15px 0;
    padding-left: 25px;
}

.option-list li {
    margin-bottom: 10px;
    padding: 8px;
    border-left: 3px solid #e0e6ed;
    padding-left: 15px;
}

.answer-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px dashed #e0e6ed;
}

.answer-title {
    font-weight: 700;
    margin-bottom: 15px;
    color: #27ae60;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.2rem;
}

.answer-content {
    background: #f9fdf9;
    padding: 20px;
    border-radius: 10px;
    border-left: 4px solid #27ae60;
}

.preview-area {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #f0f4f8;
}

.preview-title {
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 30px;
    color: #2c3e50;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.empty-state {
    text-align: center;
    padding: 50px 20px;
    color: #95a5a6;
    border: 2px dashed #e0e6ed;
    border-radius: 15px;
    background: #f9fbfd;
}

.empty-state i {
    font-size: 4rem;
    margin-bottom: 20px;
    color: #d5dbdb;
}

.empty-state h3 {
    font-size: 1.8rem;
    margin-bottom: 15px;
    color: #7f8c8d;
}

.empty-state p {
    font-size: 1.1rem;
    max-width: 600px;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .input-row {
        flex-direction: column;
        gap: 15px;
    }

    .btn-group {
        flex-direction: column;
    }

    .mode-selector {
        flex-direction: column;
    }
}
</style>